module.exports = __webpack_public_path__ + "static/media/score_four.37c86ae5.png";